import React from 'react'
import { Box, WaitTillLoaded } from '@plvs/respawn/features/layout'
import { NxTypography } from '@playvs-inc/nexus-components'
import { makeStyles, useTheme } from '@material-ui/core'
import { OrgTypeLogo } from '@plvs/respawn/components/logo/OrgTypeLogo'
import { MatchOverlayTeamCluster } from '@plvs/respawn/features/overlay/matchOverlay/components/MatchOverlayTeamCluster'
import './MatchOverlay.css'
import { useMatchOverlay } from '@plvs/respawn/features/overlay/useMatchOverlay'

const useStyles = makeStyles({
  animation: {
    animation: 'jelloWithPause 122s ease 0s infinite normal forwards',
  },
  leagueName: {
    fontSize: '1.75rem',
  },
  metaseasonName: {
    fontSize: '1.5rem',
  },
  score: {
    fontSize: '5rem',
  },
})

export const MatchOverlay: React.FC = () => {
  const styles = useStyles()
  const theme = useTheme()

  const {
    slot,
    league,
    metaseason,
    homeTeam,
    awayTeam,
    team1Score,
    team2Score,
    isMatchPending,
    loading,
  } = useMatchOverlay()

  return (
    <Box
      display="flex"
      flex={1}
      flexDirection="column"
      padding={theme.spacing(5)}
    >
      <WaitTillLoaded loading={loading}>
        <Box display="flex" flex={1} flexDirection="column">
          <Box textAlign="center">
            <NxTypography className={styles.leagueName} variant="h3">
              {league?.name}
            </NxTypography>
            <NxTypography className={styles.metaseasonName} variant="h4">
              {metaseason?.name} - {slot?.name}
            </NxTypography>
          </Box>

          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            mt={10}
            textAlign="center"
          >
            <MatchOverlayTeamCluster
              showHotstreak={team1Score > team2Score}
              team={homeTeam}
            />

            <Box textAlign="center">
              {isMatchPending ? (
                <NxTypography className={styles.score} variant="display">
                  VS
                </NxTypography>
              ) : (
                <NxTypography className={styles.score} variant="display">
                  {team1Score} - {team2Score}
                </NxTypography>
              )}
            </Box>

            <MatchOverlayTeamCluster
              showHotstreak={team1Score < team2Score}
              team={awayTeam}
            />
          </Box>

          <Box
            alignItems="flex-end"
            className={styles.animation}
            display="flex"
            flex={1}
            justifyContent="center"
          >
            <OrgTypeLogo
              competitionGroup={homeTeam?.competitionGroup}
              height={100}
              isDarkMode={false}
            />
          </Box>
        </Box>
      </WaitTillLoaded>
    </Box>
  )
}
